export { schoolTypeTranslates, schoolTypesOptions } from './school-type-options';
export { studentsAddModeTranslates, studentsAddModeOptions } from './students-add-mode';
